import type { ReactNode } from 'react';

export interface BadgeProps {
  children: ReactNode;
  color?: 'warning' | 'success' | 'primary' | 'neutral';
  className?: string;
}

const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');

const colorClasses: Record<NonNullable<BadgeProps['color']>, string> = {
  warning: 'bg-warning text-white',
  success: 'bg-success/15 text-success',
  primary: 'bg-primary/15 text-primary-strong',
  neutral: 'bg-line-light text-ink-secondary',
};

/** Small uppercase status badge ("Upcoming", "Verified", ...). */
export function Badge({ children, color = 'primary', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-extrabold uppercase tracking-wide',
        colorClasses[color],
        className,
      )}
    >
      {children}
    </span>
  );
}
